import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Reseller } from "./reseller.model";

@Injectable()
export class ResellerService extends CrudService {
  getRootUrl(): string {
    return "resellers";
  }

  save(reseller) {
    return super.save(reseller);
  }

  saveMultiple(resellers: Array<Reseller>) {
    return super.saveMultiple(resellers);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/resellers/shared/reseller.service.ts